import { ALERT_SEVERITY, ERROR_MESSAGES } from "eebac/constants";
import { Catch } from "./api_exception";
import { setGlobalMessage, setLoading } from "./app";

const BASE_PATH = 'FORGOT_PASSWORD_DATA';

export const SET_FORGOT_PASSWORD_DATA = `${BASE_PATH}/SET_FORGOT_PASSWORD_DATA`;
export const CLEART_DATA = `${BASE_PATH}/CLEART_DATA`;
export const SET_IS_PASSWORD_CHANGED = `${BASE_PATH}/SET_IS_PASSWORD_CHANGED`;

export const onForgotPassword = (isResend = false) =>
    (dispatch, getState, client) => {
        dispatch(setLoading(true));
        let state = getState().FORGOT_PASSWORD_DATA;
        client.post(`/auth/forgot-password`, {
            email: state.email,
            isResendOtp: isResend,
            otpToken: state.otpToken
        }).
            then(res => res.data).then(result => {
                if (result.isSuccess) {
                    dispatch(setData([{
                        key: 'openOtpDialog',
                        value: true
                    },
                    {
                        key: 'otpToken',
                        value: result.data.otpToken
                    }, {
                        key: 'otp',
                        value: ""
                    }]));
                    if (result.successMessage && isResend) {
                        dispatch(setGlobalMessage(result.successMessage, ALERT_SEVERITY.SUCCESS));
                    }
                } else {
                    dispatch(setGlobalMessage(result.errorMessage ?
                        result.errorMessage :
                        ERROR_MESSAGES.SERVER_FAULT, ALERT_SEVERITY.ERROR));
                }
                dispatch(setLoading(false));
            }).catch(error => {
                Catch(error, dispatch);
            });
    }

export const verifyOtp = () =>
    (dispatch, getState, client) => {

        dispatch(setData([
            { key: "isProcessing", value: true },
            { key: "otpError", value: '' }
        ]));

        let state = getState().FORGOT_PASSWORD_DATA;
        client.post('/auth/forgot-password/verifyOtp', {
            otp: state.otp,
            otpToken: state.otpToken,
            email: state.email
        }).then(res => res.data).then(result => {

            dispatch(setData([
                { key: "isProcessing", value: false }
            ]));

            if (result.isSuccess) {
                dispatch(setData([{
                    key: 'openOtpDialog',
                    value: false
                },
                {
                    key: "isOtpVerified",
                    value: true
                },
                {
                    key: 'otpToken',
                    value: result.data.otpToken
                }, {
                    key: 'otp',
                    value: ""
                }]));
            } else {

                dispatch(setGlobalMessage(result.errorMessage ?
                    result.errorMessage :
                    ERROR_MESSAGES.SERVER_FAULT, ALERT_SEVERITY.ERROR));
            }
        }).catch(error => {
            dispatch(setData([
                {
                    key: "isProcessing",
                    value: false
                }
            ]));
            Catch(error, dispatch);
        });
    }

export const resetPassword = () =>
    (dispatch, getState, client) => {
        dispatch(setLoading(true));
        let state = getState().FORGOT_PASSWORD_DATA;
        client.post(`/auth/reset-password`, {
            email: state.email,
            password: state.password,
            otpToken: state.otpToken
        }).
            then(res => res.data).then(result => {
                if (result.isSuccess) {

                    dispatch(clearData());
                    dispatch(setData([{ key: "isPasswordChanged", value: true }]));

                    dispatch(setGlobalMessage(result.successMessage, ALERT_SEVERITY.SUCCESS));
                } else {
                    dispatch(setGlobalMessage(result.errorMessage ?
                        result.errorMessage :
                        ERROR_MESSAGES.SERVER_FAULT, ALERT_SEVERITY.ERROR));
                }
                dispatch(setLoading(false));
            }).catch(error => {
                Catch(error, dispatch);
            });
    }
export const setData = data => ({
    type: SET_FORGOT_PASSWORD_DATA,
    data
});

export const setIsPasswordChanged = (isPasswordChanged) => ({
    type: SET_IS_PASSWORD_CHANGED,
    isPasswordChanged
});

export const clearData = () => ({
    type: CLEART_DATA,
});


const initialState = {
    errorMessage: '',
    email: '',
    emailError: '',
    openOtpDialog: false,
    otp: '',
    otpError: '',
    isProcessing: false,
    otpToken: '',
    isOtpVerified: false,
    password: '',
    passwordError: '',
    isPasswordChanged: false,
}

export default function reducer(state = initialState, action) {
    switch (action.type) {
        case SET_FORGOT_PASSWORD_DATA:
            let newState = { ...state };
            action.data.forEach(data => {
                newState[data.key] = data.value;
            });
            return newState;
        case SET_IS_PASSWORD_CHANGED:
            return {
                ...state,
                isPasswordChanged: action.isPasswordChanged
            };
        case CLEART_DATA:
            return {
                ...initialState
            };
        default:
            break;
    }

    return state;
}